import React from "react";

const CaptureVideo = ({ kycDoc, roomId }) => {
  const clientAddressProof =
    (kycDoc && kycDoc.filter((item) => item.doctype === "kyc_video")) || [];
  console.log(clientAddressProof[0], "clientAddressProof");
  
  return (
    <div>
      <div className="mobheight brdr text-center">
        <p className="reward24 md:postionleft">Webcam & MIC</p>
        {clientAddressProof.length > 0 && clientAddressProof[0].sinzey_doc_url_front ? (
          <div >
            <p className="reward24 md:postionleft">Captured Video:</p>
            {/* <video
              src={clientAddressProof[0].sinzey_doc_url_front}
              controls
              style={{ width: "80%" }}
            /> */}
          </div>
        ) : (
          <img
            src="assets/images/webcam.svg"
            alt="Webcam Icon"
            className="md:postionright mb-5 w-50"
          />
        )}
      </div>
    </div>
  );
};

export default CaptureVideo;
